var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9 2.75C4.9 2.33579 5.23579 2 5.65 2H14.35C14.7642 2 15.1 2.33579 15.1 2.75V7.075H15.8C16.3835 7.075 16.9431 7.30679 17.3556 7.71937C17.7682 8.13195 18 8.69152 18 9.275V12.9C18 13.4835 17.7682 14.0431 17.3556 14.4556C16.9431 14.8682 16.3835 15.1 15.8 15.1H15.1V17.25C15.1 17.6642 14.7642 18 14.35 18H5.65C5.23579 18 4.9 17.6642 4.9 17.25V15.1H4.2C3.61652 15.1 3.05695 14.8682 2.64437 14.4556C2.23178 14.0431 2 13.4835 2 12.9V9.275C2 8.69152 2.23179 8.13195 2.64437 7.71937C3.05694 7.30679 3.61652 7.075 4.2 7.075H4.9V2.75ZM4.2 8.575C4.01435 8.575 3.8363 8.64875 3.70503 8.78003C3.57375 8.9113 3.5 9.08935 3.5 9.275V12.9C3.5 13.0857 3.57375 13.2637 3.70503 13.395C3.8363 13.5263 4.01435 13.6 4.2 13.6H4.9V11.45C4.9 11.0358 5.23579 10.7 5.65 10.7H14.35C14.7642 10.7 15.1 11.0358 15.1 11.45V13.6H15.8C15.9857 13.6 16.1637 13.5263 16.295 13.395C16.4263 13.2637 16.5 13.0857 16.5 12.9V9.275C16.5 9.08935 16.4263 8.9113 16.295 8.78003C16.1637 8.64875 15.9857 8.575 15.8 8.575H4.2ZM13.6 7.075H6.4V3.5H13.6V7.075ZM13.6 12.2H6.4V16.5H13.6V12.2Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "f6fd12e43ffea4b46d861fa8a0c2cc7c.svg";
export { ForwardRef as ReactComponent };